import { BodyLinkV3 } from '@jouzen/ecom-components';
import type { ReactNode } from 'react';

import type { SectionProps } from '../_components/TAndCSection';

const values = {
  Link: (chunks: ReactNode) => {
    const href = Array.isArray(chunks)
      ? (chunks[0] as string)
      : (chunks as string);
    return <BodyLinkV3 href={href}>{chunks}</BodyLinkV3>;
  },
};

const SECTION_DATA: Omit<SectionProps, 'index'>[] = [
  {
    title: 'b2b_terms_1_title',
    terms: [
      {
        term: 'b2b_terms_1_1_term',
        content: 'b2b_terms_1_1_def',
      },
      {
        term: 'b2b_terms_1_2_term',
        content: 'b2b_terms_1_2_def',
      },
      {
        term: 'b2b_terms_1_3_term',
        content: 'b2b_terms_1_3_def',
      },
      {
        term: 'b2b_terms_1_4_term',
        content: 'b2b_terms_1_4_def',
      },
      {
        term: 'b2b_terms_1_5_term',
        content: 'b2b_terms_1_5_def',
      },
      {
        term: 'b2b_terms_1_6_term',
        content: 'b2b_terms_1_6_def',
      },
      {
        term: 'b2b_terms_1_7_term',
        content: 'b2b_terms_1_7_def',
      },
      {
        term: 'b2b_terms_1_8_term',
        content: 'b2b_terms_1_8_def',
      },
      {
        term: 'b2b_terms_1_9_term',
        content: 'b2b_terms_1_9_def',
      },
      {
        term: 'b2b_terms_1_10_term',
        content: 'b2b_terms_1_10_def',
      },
      {
        term: 'b2b_terms_1_11_term',
        content: 'b2b_terms_1_11_def',
      },
    ],
  },
  {
    title: 'b2b_terms_2_title',
    terms: [
      {
        term: 'b2b_terms_2_1_term',
        content: 'b2b_terms_2_1_def',
      },
      {
        term: 'b2b_terms_2_2_term',
        content: 'b2b_terms_2_2_def',
      },
      {
        term: 'b2b_terms_2_3_term',
        content: 'b2b_terms_2_3_def',
      },
      {
        term: 'b2b_terms_2_4_term',
        content: 'b2b_terms_2_4_def',
      },
      {
        term: 'b2b_terms_2_5_term',
        content: 'b2b_terms_2_5_def',
      },
      {
        term: 'b2b_terms_2_6_term',
        content: 'b2b_terms_2_6_def',
      },
      {
        term: 'b2b_terms_2_7_term',
        content: 'b2b_terms_2_7_def',
      },
      {
        term: 'b2b_terms_2_8_term',
        content: 'b2b_terms_2_8_def',
      },
    ],
  },
  {
    title: 'b2b_terms_3_title',
    terms: [
      {
        term: 'b2b_terms_3_1_term',
        content: 'b2b_terms_3_1_def',
      },
      {
        term: 'b2b_terms_3_2_term',
        content: 'b2b_terms_3_2_def',
      },
      {
        term: 'b2b_terms_3_3_term',
        content: 'b2b_terms_3_3_def',
      },
      {
        term: 'b2b_terms_3_4_term',
        content: 'b2b_terms_3_4_def',
      },
      {
        term: 'b2b_terms_3_5_term',
        content: 'b2b_terms_3_5_def',
      },
    ],
  },
  {
    title: 'b2b_terms_4_title',
    terms: [
      {
        term: 'b2b_terms_4_1_term',
        content: 'b2b_terms_4_1_def',
      },
      {
        term: 'b2b_terms_4_2_term',
        content: 'b2b_terms_4_2_def',
      },
      {
        term: 'b2b_terms_4_3_term',
        content: 'b2b_terms_4_3_def',
      },
      {
        term: 'b2b_terms_4_4_term',
        content: 'b2b_terms_4_4_def',
      },
    ],
  },
  {
    title: 'b2b_terms_5_title',
    terms: [
      {
        term: 'b2b_terms_5_1_term',
        content: 'b2b_terms_5_1_def',
        values,
      },
      {
        term: 'b2b_terms_5_2_term',
        content: 'b2b_terms_5_2_def',
      },
      {
        term: 'b2b_terms_5_3_term',
        content: 'b2b_terms_5_3_def',
      },
    ],
  },
  {
    title: 'b2b_terms_6_title',
    terms: [
      {
        term: 'b2b_terms_6_1_term',
        content: 'b2b_terms_6_1_def',
      },
      {
        term: 'b2b_terms_6_2_term',
        content: 'b2b_terms_6_2_def',
      },
      {
        term: 'b2b_terms_6_3_term',
        content: 'b2b_terms_6_3_def',
      },
    ],
  },
  {
    title: 'b2b_terms_7_title',
    terms: [
      {
        term: 'b2b_terms_7_1_term',
        content: 'b2b_terms_7_1_def',
      },
      {
        term: 'b2b_terms_7_2_term',
        content: 'b2b_terms_7_2_def',
      },
    ],
  },
  {
    title: 'b2b_terms_8_title',
    terms: [
      {
        term: 'b2b_terms_8_1_term',
        content: 'b2b_terms_8_1_def',
      },
      {
        term: 'b2b_terms_8_2_term',
        content: 'b2b_terms_8_2_def',
      },
      {
        term: 'b2b_terms_8_3_term',
        content: 'b2b_terms_8_3_def',
      },
      {
        term: 'b2b_terms_8_4_term',
        content: 'b2b_terms_8_4_def',
      },
      {
        term: 'b2b_terms_8_5_term',
        content: 'b2b_terms_8_5_def',
      },
    ],
  },
  {
    title: 'b2b_terms_9_title',
    terms: [
      {
        term: 'b2b_terms_9_1_term',
        content: 'b2b_terms_9_1_def',
      },
      {
        term: 'b2b_terms_9_2_term',
        content: 'b2b_terms_9_2_def',
      },
      {
        term: 'b2b_terms_9_3_term',
        content: 'b2b_terms_9_3_def',
      },
      {
        term: 'b2b_terms_9_4_term',
        content: 'b2b_terms_9_4_def',
      },
      {
        term: 'b2b_terms_9_5_term',
        content: 'b2b_terms_9_5_def',
      },
      {
        term: 'b2b_terms_9_6_term',
        content: 'b2b_terms_9_6_def',
      },
      {
        term: 'b2b_terms_9_7_term',
        content: 'b2b_terms_9_7_def',
      },
      {
        term: 'b2b_terms_9_8_term',
        content: 'b2b_terms_9_8_def',
      },
      {
        term: 'b2b_terms_9_9_term',
        content: 'b2b_terms_9_9_def',
      },
      {
        term: 'b2b_terms_9_10_term',
        content: 'b2b_terms_9_10_def',
      },
      {
        term: 'b2b_terms_9_11_term',
        content: 'b2b_terms_9_11_def',
      },
      {
        term: 'b2b_terms_9_12_term',
        content: 'b2b_terms_9_12_def',
      },
      {
        term: 'b2b_terms_9_13_term',
        content: 'b2b_terms_9_13_def',
      },
      {
        term: 'b2b_terms_9_14_term',
        content: 'b2b_terms_9_14_def',
      },
    ],
  },
  {
    title: 'b2b_terms_10_title',
    terms: [
      {
        content: 'b2b_terms_10_1_def',
      },
      {
        content: 'b2b_terms_10_2_def',
      },
      {
        content: 'b2b_terms_10_3_def',
      },
      {
        content: 'b2b_terms_10_4_def',
      },
      {
        content: 'b2b_terms_10_5_def',
      },
      {
        content: 'b2b_terms_10_6_def',
      },
      {
        content: 'b2b_terms_10_7_def',
      },
      {
        content: 'b2b_terms_10_8_def',
      },
      {
        content: 'b2b_terms_10_9_def',
        values,
      },
      {
        content: 'b2b_terms_10_10_def',
      },
      {
        content: 'b2b_terms_10_11_def',
      },
      {
        content: 'b2b_terms_10_12_def',
      },
      {
        content: 'b2b_terms_10_13_def',
      },
      {
        content: 'b2b_terms_10_14_def',
      },
      {
        content: 'b2b_terms_10_15_def',
      },
      {
        content: 'b2b_terms_10_16_def',
      },
      {
        content: 'b2b_terms_10_17_def',
      },
      {
        content: 'b2b_terms_10_18_def',
      },
      {
        content: 'b2b_terms_10_19_def',
        values,
      },
      {
        content: 'b2b_terms_10_20_def',
      },
      {
        content: 'b2b_terms_10_21_def',
        values,
      },
      {
        content: 'b2b_terms_10_22_def',
      },
      {
        content: 'b2b_terms_10_23_def',
      },
      {
        content: 'b2b_terms_10_24_def',
      },
    ],
  },
];

export default SECTION_DATA;
